import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';

import useStarredDataHomeStarredPagesQuery, {
	type useStarredDataHomeStarredPagesQuery$data,
	type useStarredDataHomeStarredPagesQuery$variables,
} from './__generated__/useStarredDataHomeStarredPagesQuery.graphql.ts';

const PAGE_SIZE = 24;

export const preloadStarred = ({ isLoggedIn }) => {
	return waitForAllReturnWhenError([
		query<useStarredDataHomeStarredPagesQuery$data, useStarredDataHomeStarredPagesQuery$variables>({
			query: useStarredDataHomeStarredPagesQuery,
			variables: {
				limit: PAGE_SIZE,
				start: 0,
			},
		}),
		preloadOptions({ isLoggedIn }),
	]);
};
